import { AdditionalField } from '@prisma/client';
import { CurrencySymbol } from 'context/MenuContext';
import { AccountWithRelations, OrderWithRelation, ReducedAccount } from 'Types';

export const deepEqual = (a: any, b: any) =>
  JSON.stringify(a) === JSON.stringify(b);

export const hasDecimals = (n: number): boolean => n - Math.floor(n) !== 0;

export const getPrice = (price: number): string =>
  hasDecimals(price) ? price.toFixed(2) : price.toString();

export const getFormatedPrice = (
  price: number,
  currencySymbol?: CurrencySymbol
) =>
  currencySymbol === '$'
    ? `${currencySymbol || ''} ${getPrice(price)} `
    : `${getPrice(price)} ${currencySymbol || ''} `;

export const removeKeys = (obj: any, keys: string[] = ['updatedAt']) => {
  if (!obj) return;
  const newObj = JSON.parse(JSON.stringify(obj));
  const removeKeysFromObject = (obj: any, keys: string[]) => {
    if (!obj) return;
    keys.forEach((key) => {
      if (obj[key]) delete obj[key];
    });
    Object.keys(obj).forEach((key) => {
      if (typeof obj[key] === 'object') {
        removeKeysFromObject(obj[key], keys);
      }
    });
  };
  removeKeysFromObject(newObj, keys);
  return newObj;
};

export const removeAccents = (str: string) => {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

export const createSlug = (s: string): string => {
  let value = s || '';
  const last = value.slice(-1);
  if (last === '-') {
    value = value.slice(0, -1);
  }

  return removeAccents(value)
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .slice(0, 50);
};

export const getClientNumber = (
  order: Omit<OrderWithRelation, 'account'>,
  additionalFields: AdditionalField[]
): string => {
  if (order.customerPhone) {
    return order.customerPhone;
  }
  const customerPhoneField = additionalFields.find(
    (f) => f.specialField === 'PHONE_NUMBER'
  );
  if (customerPhoneField) {
    const value = order.additionalData.find(
      (f) => f.fieldId === customerPhoneField.id
    )?.value;
    if (value) return JSON.parse(value);
  }
  return '';
};
export const getCustomerName = (
  order: Omit<OrderWithRelation, 'account'>,
  additionalFields: AdditionalField[]
): string => {
  if (order.customerName) {
    return order.customerName;
  }
  const customerNameField = additionalFields.find(
    (f) => f.specialField === 'CUSTOMER_NAME'
  );
  if (customerNameField) {
    const value = order.additionalData.find(
      (f) => f.fieldId === customerNameField.id
    )?.value;
    if (value) return JSON.parse(value);
  }
  return '';
};

export const parse = <T>(obj: T): T => JSON.parse(JSON.stringify(obj));
